import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CommonModule } from '@angular/common';
import { OwlModule } from 'ngx-owl-carousel';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LandingModule } from './pages/landing-page/landing.module';
import { ContactUsModule } from './pages/contact-us/contact.module';
import { PricingModule } from './pages/pricing-plan/pricing.module';
import { SharedModule } from './shared/shared.module';
import { DatabaseHostingModule } from './pages/database-hosting/database-hosting.module';
import { WebpageHostingModule } from './pages/webpage-hosting/webpage-hosting-module';
import { LoginModule } from './components/login/login.module';
import { RegistrationModule } from './components/registration/registation.module';
import { ClusterHostingModule } from './pages/cluster-hosting/cluster-hosting.module';
import { ProductModule } from './pages/product-page/product.module';
import { DatabaseMigrationModule } from './pages/database-migration/database-migration.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule, 
    HttpClientModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    LandingModule,
    ContactUsModule,
    PricingModule,
    SharedModule,
    DatabaseHostingModule,
    WebpageHostingModule,
    LoginModule,
    RegistrationModule,
    ClusterHostingModule,
    ProductModule,
    DatabaseMigrationModule,
    NgCircleProgressModule.forRoot({
      radius: 50,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300
    }),
    OwlModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
